var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartSquarePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-square-plus",
    clipPath: "url(#clip0_7975_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.1269 3.47488L13.6269 3.46814C15.027 3.46545 15.7271 3.4641 16.2624 3.73556C16.7333 3.97433 17.1165 4.35605 17.357 4.82599C17.6306 5.36024 17.6319 6.06031 17.6346 7.46044L17.6481 14.4604C17.6508 15.8606 17.6521 16.5606 17.3807 17.0959C17.1419 17.5668 16.7602 17.95 16.2902 18.1906C15.756 18.4641 15.0559 18.4654 13.6558 18.4681L6.6558 18.4816C5.25567 18.4843 4.5556 18.4856 4.0203 18.2142C3.54943 17.9754 3.16625 17.5937 2.92566 17.1237C2.65215 16.5895 2.6508 15.8894 2.6481 14.4893L2.64137 10.9893M6.80963 11.8146L6.81605 15.1479M13.4731 10.1351L13.4827 15.1351M10.1333 6.80821L10.1494 15.1415M4.30161 7.65277L4.29199 2.65278M1.7968 5.15759L6.7968 5.14796",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7975_3127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.12207 0.994141) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSquarePlus);
export default __webpack_public_path__ + "static/media/bar-chart-square-plus.869e44b1c52461012f2fabca12251ba9.svg";
export { ForwardRef as ReactComponent };